<template>
  <div class="sidebar">
    <media :query="{ maxWidth: screens.md - 1 }">
      <div class="meta-nav">
        <TestSend
          class="meta-link mr-1 sm:mr-2"
          :sending-test="sendingTest"
          icon-position="left"
          :icon-scale="0.7"
          @test-send="$emit('test-send')"
        />

        <SupportNav location="sidebar" />
      </div>
    </media>

    <div ref="tabsWrap" class="tabs-wrap">
      <tabs cache-lifetime="0" :options="{ useUrlFragment: false }">
        <!-- FIXME: Disable useUrlFragment and tabChanged due to SendCampaignModal re opening on each change  -->
        <!-- @changed="tabChanged" -->
        <tab name="Content" class="tab-content">
          <Content :campaign="campaign" />
        </tab>
        <tab name="Layout" class="tab-content">
          <Layout :campaign="campaign" />
        </tab>
        <tab name="Settings" class="tab-content">
          <Settings :campaign="campaign" :tabs-wrap-ref="$refs.tabsWrap" />
        </tab>
        <tab v-if="DEVELOPMENT" name="Template" class="tab-content">
          <Template :campaign-id="campaign.campaignId" />
        </tab>
      </tabs>
    </div>
  </div>
</template>

<script>
import Media from "vue-media";
import Content from "@/components/Editor/Content/Content";
import Layout from "@/components/Editor/Layout/Layout";
import Settings from "@/components/Editor/Settings/Settings";
import Template from "@/components/Editor/Template/Template";
import TestSend from "@/components/Editor/TestSend";
import SupportNav from "@/components/Editor/SupportNav";

export default {
  name: "Sidebar",
  inject: ["DEVELOPMENT", "screens"],
  components: {
    Content,
    Layout,
    Media,
    Settings,
    SupportNav,
    Template,
    TestSend,
  },
  props: {
    campaign: {
      required: true,
      type: Object,
    },
    mobileSidebar: {
      default: false,
      type: Boolean,
    },
    sendingTest: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style scoped>
.sidebar {
  @apply h-full relative bg-white;
}

.tabs-wrap {
  @apply h-full overflow-auto bg-white;
}

.meta-nav {
  @apply flex items-center justify-center border-grey-lighter border-b border-t bg-grey-lightest px-2 py-2;

  @screen sm {
    @apply px-4;
  }
}

.meta-link {
  @apply text-grey-dark font-normal font-sans text-xs p-0 mr-2 no-underline;

  &:hover {
    @apply text-brand-lighter;
  }

  @screen md {
    @apply px-0 text-grey font-light;
  }
}
</style>
